var exports = {
  "K": "xfd349460--8922cd--icon",
};

module.exports = exports;
